import { X } from "lucide-react"
import * as Dialog from "@radix-ui/react-dialog"
import { focusRing } from "../lightTheme"

const cardShadow =
  "shadow-[0_0_0_1px_rgba(0,0,0,0.08),0_2px_2px_0_rgba(0,0,0,0.04),0_8px_16px_-4px_rgba(0,0,0,0.04),0_0_0_1px_#FAFAFA]"

function DocumentBlock({ block }) {
  if (block.type === "heading") {
    return (
      <h3 className="text-[16px] font-medium leading-6 text-[#171717]">{block.text}</h3>
    )
  }
  if (block.type === "mailto") {
    return (
      <a href={block.href} className="text-[16px] font-normal leading-6 text-[#171717] underline">
        {block.label}
      </a>
    )
  }
  return <p className="text-[16px] font-normal leading-6 text-[#4D4D4D]">{block.text}</p>
}

export default function LegalDocumentModal({ document, onClose, returnFocusRef }) {
  if (!document) return null

  return (
    <Dialog.Root
      open
      onOpenChange={(open) => {
        if (!open) onClose()
      }}
    >
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-[70] bg-black/40" />
        <Dialog.Content
          aria-describedby={undefined}
          className={`fixed left-1/2 top-1/2 z-[70] flex max-h-[calc(100vh-3rem)] w-[min(640px,calc(100%-3rem))] -translate-x-1/2 -translate-y-1/2 flex-col overflow-hidden rounded-xl bg-white outline-none ${cardShadow}`}
          onCloseAutoFocus={(event) => {
            event.preventDefault()
            returnFocusRef?.current?.focus()
          }}
        >
          <div className="flex shrink-0 items-center justify-between gap-4 px-6 pt-6">
            <Dialog.Title className="text-[24px] font-normal leading-8 tracking-[-0.04em] text-[#171717]">
              {document.title}
            </Dialog.Title>
            <Dialog.Close
              className={`flex size-8 shrink-0 cursor-pointer items-center justify-center rounded-full bg-white text-[#171717] shadow-[0_0_0_1px_rgba(0,0,0,0.08)] ${focusRing}`}
            >
              <X className="size-4" aria-hidden="true" />
              <span className="sr-only">Close</span>
            </Dialog.Close>
          </div>
          <div className="flex min-h-0 flex-col gap-4 overflow-y-auto px-6 pb-6 pt-4">
            {document.blocks.map((block, index) => (
              <DocumentBlock key={`${block.type}-${index}`} block={block} />
            ))}
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
